import { render, staticRenderFns } from "./assignClerk.vue?vue&type=template&id=433ed774&scoped=true"
import script from "./assignClerk.vue?vue&type=script&lang=js"
export * from "./assignClerk.vue?vue&type=script&lang=js"
import style0 from "./assignClerk.vue?vue&type=style&index=0&id=433ed774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433ed774",
  null
  
)

export default component.exports